module.exports = __webpack_public_path__ + "img/ocean-hotel-8.bfaab1aa.jpg";